<template>
  <v-dialog
    v-if="translations"
    v-model="languageDialog"
    :fullscreen="$vuetify.breakpoint.mdAndDown"
    max-width="400"
    scrollable
    persistent>
    <v-card data-testid="language-dialog-card">
      <v-card-title class="pa-2" data-testid="card-header-title">
        <v-btn icon @click="show=false" :class="{'mr-4' : !$vuetify.rtl, 'ml-4' : $vuetify.rtl}"
          :aria-label="$t('a11y.btn_close')" data-testid="language-dialog-close">
          <v-icon>close</v-icon>
        </v-btn>
        {{ computedTitleText }}
      </v-card-title>

      <v-card-text data-testid="card-container">
        <v-list class="menu-list">
          <v-list-item-group
            v-model="selectedLanguage"
            color="primary">
          <v-list-item v-for="(lang, i) in translations" :key="i" :value="lang.value">
            <template v-slot:default="{ active }">
              <v-list-item-title v-text="lang.text"></v-list-item-title>
              <v-list-item-icon v-if="active">
                <v-icon>radio_button_checked</v-icon>
              </v-list-item-icon>
            </template>
          </v-list-item>
          </v-list-item-group>
          </v-list>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
          <v-btn color="primary" text @click="save()">{{ computedSaveButtonText }}</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'LanguageDialog',
  components: {
  },
  props: {
    title: {
      type: String,
      default: undefined
    },
    saveButtonText: {
      type: String,
      default: undefined
    },
    languageDialog: Boolean,
    translations: Array
  },
  data () {
    return {
      selectedLanguage: 'en'
    }
  },
  methods: {
    save() {
      let lang_code = this.selectedLanguage;
      this.$root.changeLanguage(lang_code);
      this.$emit('close')
    }
  },
 computed: {
    show: {
      get () {
        return this.languageDialog;
      },
      set (value) {
        if (!value) {
          this.$emit('close');
        }
        else {
          this.selectedLanguage = this.$root.getCurrentLanguage();
        }
      }
    },
    /*
    translations() {
      let available_translations = this.$root.getSetting('translations');
      if (available_translations == null) {
        return null;
      }
      return this.$root.getSetting('translations').map(lang => {
          return {
            text: lang.displayName,
            value: lang.code,
            disabled: false,
          }
        });
    },
    */
    computedTitleText() {
       if (this.title !== undefined) {
        return this.title;
      }
      return this.$t('account_menu.language', this.$t('language'));
    },
    computedSaveButtonText() {
      if (this.saveButtonText !== undefined) {
        return this.saveButtonText;
      }
      return this.$t('save');
    }
  },
  mounted() {
    this.selectedLanguage = this.$root.getCurrentLanguage();
  },
  beforeDestroy() {
  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/ui/LanguageDialog.vue